import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  background: var(--darkGrey);
  padding: 0 20px;
`;

export const Content = styled.div`
  position: relative;
  max-width: var(--maxWidth);
  width: 100%;
  height: 25px;
  background: var(--medGrey);
  margin: 0 auto;
  border-radius: 25px;
  color: var(--white);

  img {
    position: absolute;
    left: 15px;
    top: 5px;
    width: 15px;
  }

  input {
    font-size: 13px;
    position: absolute;
    left: 0;
    margin: 0px 0;
    padding: 0 0 0 60px;
    border: 0;
    width: 95%;
    background: transparent;
    height: 25px;
    color: var(--white);

    :focus {
      outline: none;
    }
  }
`;
